import React, { useState } from "react";
import { useWebHaptics } from "web-haptics/react";
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useEffect, useRef } from "react";
import axios from "axios"
import Checkout from "./Checkout";
import RegisterSocial from "./RegisterSocial";
import { Modal, Form } from "react-bootstrap";
import InputMask from 'react-input-mask';
import ProfileSwitcher from "./ProfileSwitcher";
import injectCollectJS from '../injectCollect';
import { useLanguage } from "../contexts/LanguageContext";





const Pricing = ({profile, rank }) => {
  const L = useLanguage();
  const { trigger: haptic } = useWebHaptics();
  const interval = "monthly";

  const [photo, setPhoto] = useState(profile?.socials?.[profile?.selectedProfile]?.photo || "/images/default.png");
  const [username, setUsername] = useState(profile?.socials?.[profile?.selectedProfile]?.username || null);
  const [show, setShow] = useState(false);
  const [planName, setPlanName] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingPlanChange, setPendingPlanChange] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [cardError, setCardError] = useState('');
  const cardRef = useRef(null);
  const expRef = useRef(null);
  const cvvRef = useRef(null);

  const [currentUrl, setCurrentUrl] = useState("");
  const [isHomePage, setIsHomePage] = useState(false);
  const mountedRef = useRef(true);
  useEffect(() => {
    const url = window.location.href;
    setCurrentUrl(url);
    setIsHomePage(window.location.pathname === "/" || window.location.pathname === "/home");
  }, []);


  // Show free trial button only on home page
  const showFreeTrial = isHomePage && !profile;

  
  // Structural plan data only — all user-visible text lives in L.pricing.plans[plan.url]
  const plans = [

	{
		url: "pro",
		price: { monthly: 199, annual: 99 },
		wasPrice: { monthly: 400, annual: 199 },
		features: [
		  { icon: "fa-solid fa-user-group" },
		  { icon: "fa-solid fa-bolt" },
		  { icon: "fa-solid fa-user-group" },
		  { icon: "fa-solid fa-chart-line" },

		  { icon: "fa-solid fa-heart" },

		  { icon: "fa-solid fa-crosshairs", background: true },
		  { icon: "fa-solid fa-pencil", background: true },
		  { icon: "fa-solid fa-user-tie", background: true },
		],
		popular: false,
	  },
	  {
		url: "basic",
		price: { monthly: 59, annual: 29 },
		wasPrice: { monthly: 120, annual: 59 },
		features: [
		  { icon: "fa-solid fa-user-group" },
		  { icon: "fa-solid fa-bolt" },
		  { icon: "fa-solid fa-user-group" },
		  { icon: "fa-solid fa-chart-line" },
		  { icon: "fa-solid fa-heart" },
		  { icon: "fa-solid fa-crosshairs", background: true },
		  { icon: "fa-solid fa-pencil", background: true },
		],
		popular: true,
	  },

	{
		url: "starter",
		price: { monthly: 29, annual: 14 },
		wasPrice: { monthly: 60, annual: 29 },
		features: [
			{ icon: "fa-solid fa-user-group" },
			{ icon: "fa-solid fa-bolt" },
			{ icon: "fa-solid fa-user-group" },
			{ icon: "fa-solid fa-chart-line" },
		],
		popular: false
	}


  ];

  const prices = {
	"pro": {
		"monthly": "199",
		"annual": "1188",
		"annual_monthly": "99"
	},
	"basic":{
		"monthly": "59",
		"annual": "348",
		"annual_monthly": "29"
	},
	"starter":{
		"monthly": "29",
		"annual": "168",
		"annual_monthly": "14"
	}
}


  const getProRata = () => {
    try {
      // Get current plan price
      var currentPrice = prices[rank?.planName][rank?.planInterval]
     
      // Calculate remaining time in days
      const remainingDays = Math.floor((new Date(rank?.nextChargeDate) - new Date()) / (1000 * 60 * 60 * 24));
      console.log(`Remaining days: ${remainingDays}`);
      
      const remainingValue = Math.floor(currentPrice * remainingDays / (rank?.planInterval === "annual" ? 365 : 30));
      return {remainingValue, remainingDays};
    } catch (error) {
      console.log(error)
      return 0;
    }
  }



  const [nextRenewalDate, setNextRenewalDate] = useState(null);

  useEffect(() => {
    if (rank?.nextChargeDate) {
      setNextRenewalDate(new Date(rank.nextChargeDate));
    }
  }, [rank?.nextChargeDate]);


  const changePlan = async (planName, interval) => {
    setPendingPlanChange({ planName, interval });
    setShowConfirmModal(true);
  };

  const confirmPlanChange = async () => {
    try {
      setCardError('');
      if (!selectedCard) {
        setCardError(L.pricing.errSelectPayment);
        return;
      }

      const payload = {
        newPlan: pendingPlanChange.planName,
        newInterval: pendingPlanChange.interval
      };

      if (selectedCard === 'addCard') {
        const cardNumber = cardRef.current?.value?.replace(/\s/g, '');
        const expDate = expRef.current?.value;
        const cvv = cvvRef.current?.value;
        if (!cardNumber || !expDate || !cvv) {
          setCardError(L.pricing.errFillCardDetails);
          return;
        }
        payload.card = cardNumber;
        payload.exp = expDate;
        payload.cvv = cvv;
      } else {
        payload.cardid = selectedCard;
      }

      setLoading(true);
      const response = await axios.post("https://api.viralgpt.com/purchase/change-plan", payload, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      });
      if (response.data.message) {
        alert(response.data.message);
		/*axios.post("https://api.viralgpt.com/pixel", {
			email: profile.email,
			event: "Purchase",
			price: prices[pendingPlanChange.planName][pendingPlanChange.interval]
		}, {
			withCredentials: true
		})*/
        window.location.reload();
      } else {
        setCardError(L.pricing.errUpgrading(response.data.error));
      }
    } catch (error) {
      setCardError(error.response?.data?.error || L.pricing.errChangePlanFallback);
    } finally {
		setLoading(false);
    }
  };


  const loadCheckout = (planName) => {
    setShow(true);
    setPlanName(planName);
  }

  const purchasePaymentToken = async (paymenttoken, cardDetails) => {
	try {
		const response = await axios.post('https://api.viralgpt.com/purchase/change-plan', {
			paymenttoken: paymenttoken,
			newPlan: pendingPlanChange.planName,
       		newInterval: pendingPlanChange.interval
		}, {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
			}
		});
		if (response.data.message) {
			alert(response.data.message);
			/*axios.post("https://api.viralgpt.com/pixel", {
				email: profile.email,
				event: "Purchase",
				price: prices[pendingPlanChange.planName][pendingPlanChange.interval]
			}, {
				withCredentials: true
			})*/

			window.location.reload();
		  } else {
			alert(L.pricing.errUpgrading(response.data.error));
		  }
		return;
	} catch (err) {
		console.error("Error submitting form:", err);
	}
  }


  // Default the selected card whenever the confirm modal opens
  useEffect(() => {
    if (showConfirmModal) {
      setCardError('');
      const cards = profile?.cards || {};
      const cardIds = Object.keys(cards);
      const currentCardId = profile?.socials?.[profile?.selectedProfile]?.cardid;
      if (currentCardId && cards[currentCardId]) {
        setSelectedCard(String(currentCardId));
      } else if (cardIds.length > 0) {
        setSelectedCard(cardIds[0]);
      } else {
        setSelectedCard('addCard');
      }
    } else {
      setSelectedCard(null);
    }
  }, [showConfirmModal, profile]);

  // Initialize Apple Pay for plan changes when modal opens
  useEffect(() => {
    if (showConfirmModal && pendingPlanChange) {
      const price = parseFloat(prices[pendingPlanChange.planName][pendingPlanChange.interval]);
      
      console.log('Initializing Apple Pay for plan change with price:', price.toString());
      
      const timeoutId = setTimeout(() => {
        if (!mountedRef.current) return;
        
        try {
          injectCollectJS('https://secure.nmi.com/token/Collect.js', '9t4q59-U47k7W-Cj7Ty9-MbC6Y6', purchasePaymentToken, price.toString())
            .then(() => {
              if (!mountedRef.current) return;
              console.log('Apple Pay initialized for plan change with price:', price.toString());
            })
            .catch((error) => {
              if (!mountedRef.current) return;
              console.error('Error initializing Apple Pay for plan change:', error);
            });
        } catch (error) {
          if (!mountedRef.current) return;
          console.error('Error calling injectCollectJS for plan change:', error);
        }
      }, 300);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [showConfirmModal, pendingPlanChange]);






  return (
    <section id="pricing" className="stripe-section--gradient pt-5 pb-16">

      <div className="container mx-auto text-center stripe-container">

        {/* Header */}
        <div className="stripe-pricing-header">
          <h2 className="mt-2 stripe-heading stripe-heading--xl">
            {L.pricing.heading}
          </h2>
          <p className="mt-3 mx-auto stripe-body stripe-body--lg stripe-body-narrow">
            {L.pricing.sub}
          </p>
        </div>

        {/* Profile Switcher */}
        <div className="flex flex-row items-center justify-center gap-2 mb-3">
          {username && <ProfileSwitcher />}
        </div>

        {/* Skipped invoice alert */}
        <div className={`${rank?.status !== 'skipped' ? 'd-none' : ''}`}>
          <div className="alert alert-danger text-center"><i className="fas fa-exclamation-triangle me-2"></i>{L.pricing.skippedInvoice}</div>
        </div>

        {/* Inline social proof */}
        <div className="stripe-social-proof mb-4">
          <span className="stripe-social-proof-stars">
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
          </span>
          <span className="stripe-social-proof-text">{L.pricing.socialProof}</span>
        </div>

        {/* Pricing Cards */}
        <div className={`stripe-pricing-cards mx-auto mt-3 px-2 ${rank?.status === 'skipped' ? 'd-none' : ''}`}>
          <div className="row justify-content-center" style={{ overflow: 'visible' }}>
            {[...plans]
              .sort((a, b) => {
                if (a.popular && !b.popular) return -1;
                if (!a.popular && b.popular) return 1;
                return 0;
              })
              .map((plan, index) => {
              const txt = L.pricing.plans[plan.url];
              return (
              <div
                key={index}
                className={`col-12 col-lg-4 mb-4 ${plan.url === 'basic' ? 'order-0 order-lg-1 pt-0' : plan.url === 'starter' ? 'order-1 order-lg-0' : 'order-2 order-lg-2'}`}
              >
                <div
                  className={`relative text-center stripe-card stripe-pricing-card ${plan.popular ? "stripe-card--pro" : "stripe-card--flat"}`}
                  style={{ overflow: 'visible' }}
                >
                  {plan.popular && (
                    <div className="stripe-popular-pill">
                      {L.pricing.mostPopular}
                    </div>
                  )}

                  {/* Plan name */}
                  <div className="stripe-plan-name">
                    {txt.name}
                  </div>

                  {/* Price */}
                  <div className="mt-3 d-flex align-items-baseline justify-content-center" style={{ gap: '6px' }}>
                    {plan.wasPrice?.monthly && (
                      <span style={{ fontSize: '1rem', fontWeight: 600, color: '#8898aa', textDecoration: 'line-through' }}>
                        ${plan.wasPrice.monthly}
                      </span>
                    )}
                    <span className="stripe-price">
                      ${plan.price.monthly}
                    </span>
                  </div>

                  {/* Daily price anchor + 50% OFF pill */}
                  <div className="mt-1 d-flex align-items-center justify-content-center" style={{ gap: '8px', fontSize: '0.7rem', color: '#6B7280', fontWeight: 400 }}>
                    <span>{L.pricing.onlyPerDay((plan.price.monthly / 30).toFixed(2))}</span>
                    <span style={{ background: '#dcfce7', color: '#16a34a', padding: '2px 8px', borderRadius: '999px', fontSize: '0.65rem', fontWeight: 700 }}>{L.pricing.fiftyOff}</span>
                  </div>

                  {/* Plan description */}
                  <p className="mt-3 mb-0 stripe-body stripe-body--sm" style={{ color: '#556987' }}>
                    {txt.blurb}
                  </p>

                  {/* Divider */}
                  <div className="my-3 stripe-divider"></div>

                  {/* Features */}
                  <ul className="text-left mb-0" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {plan.features
                      .filter((feature, idx) => txt.features[idx]?.feature)
                      .map((feature, idx) => (
                        <OverlayTrigger
                          key={idx}
                          placement="top"
                          overlay={<Tooltip id={`tooltip-${plan.url}-${idx}`}>{txt.features[idx].description}</Tooltip>}
                        >
                          {({ ref, ...triggerHandler }) => (
                            <li
                              ref={ref}
                              {...triggerHandler}
                              className="stripe-feature-item"
                              style={feature.background ? {
                                background: 'linear-gradient(135deg, rgb(245, 243, 255) 0%, rgb(237, 233, 254) 50%, rgb(240, 249, 255) 100%)',
                                marginLeft: '-0.75rem',
                                marginRight: '-0.75rem',
                                paddingLeft: '0.75rem',
                                paddingRight: '0.75rem',
                                paddingTop: '0.6rem',
                                paddingBottom: '0.6rem',
                                borderRadius: '10px',
                                marginTop: '4px',
                                marginBottom: '4px'
                              } : {}}
                            >
                              <i className={`fa-solid fa-check stripe-feature-check ${plan.popular ? 'stripe-feature-check--pro' : ''}`}></i>
                              <span className="stripe-feature-text">
                                {txt.features[idx].feature}
                              </span>
                            </li>
                          )}
                        </OverlayTrigger>
                      ))}
                  </ul>

                  {/* CTA Buttons */}
                  <div className="mt-4">
                    {!username && profile && (
                      <>
                        <div onClick={() => setShow(true)} className="btn btn-primary bg-instagram w-full text-white stripe-btn">
                          <i className="fa-solid fa-link me-2"></i>
                          {L.pricing.linkYourProfileBtn}
                        </div>
                        <Modal show={show} onHide={() => setShow(false)} centered size="lg">
                          <Modal.Header closeButton>
                            <Modal.Title>{L.pricing.linkYourProfileTitle}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <RegisterSocial />
                          </Modal.Body>
                        </Modal>
                      </>
                    )}

                    { ((rank?.status != "active" && rank?.status != "scheduled") && profile && username) ? (
                      <>
                        <div
                          onClick={() => loadCheckout(plan.url)}
                          className={`btn w-full stripe-btn ${plan.url === "pro" ? "stripe-btn--primary" : "stripe-btn--outline"}`}
                        >
                          {txt.cta}
                        </div>
                        <Checkout
                          show={show}
                          onHide={() => setShow(false)}
                          planName={planName}
                          isAnnual={false}
                          profile={profile}
                        />
                      </>
                    ) : (
                      <>
                        {(() => {
                          const isCurrentPlan = rank?.planName == plan.url && rank?.planInterval == interval;
                          const isScheduled = rank?.scheduledPlan?.pending_plan == plan.url && rank?.scheduledPlan?.pending_interval == interval;
                          const isDowngrade = !isCurrentPlan && !isScheduled && (
                            (rank?.planName == "pro" && plan.url != "pro") ||
                            (rank?.planName == "basic" && plan.url == "starter")
                          );
                          const isInactive = isCurrentPlan || isScheduled;
                          const btnVariant = isInactive || isDowngrade ? "stripe-btn--outline" : "stripe-btn--primary";
                          return (
                            <div className={`w-full btn stripe-btn ${btnVariant} ${!username ? "d-none" : ""} ${isInactive ? "disabled" : ""}`} style={{ padding: '12px 24px' }}>
                              {isScheduled ? (
                                <div><i className="fa-solid fa-clock me-2"></i>{L.pricing.scheduledFor(nextRenewalDate ? nextRenewalDate.toLocaleDateString() : L.pricing.unknown)}</div>
                              ) : isCurrentPlan ? (
                                <div><i className="fa-solid fa-check me-2"></i>{L.pricing.currentPlan}</div>
                              ) : rank?.planName == plan.url && rank?.planInterval == "annual" ? (
                                <div onClick={() => changePlan(plan.url, interval)}><i className="fa-solid fa-calendar-day me-2"></i>{L.pricing.switchToMonthly}</div>
                              ) : rank?.planName == "pro" ? (
                                <div onClick={() => changePlan(plan.url, interval)}><i className="fa-solid fa-arrow-down me-2"></i>{L.pricing.downgrade}</div>
                              ) : rank?.planName == "basic" && plan.url == "pro" ? (
                                <div onClick={() => changePlan(plan.url, interval)}><i className="fa-solid fa-arrow-up me-2"></i>{L.pricing.upgrade}</div>
                              ) : rank?.planName == "basic" && plan.url == "starter" ? (
                                <div onClick={() => changePlan(plan.url, interval)}><i className="fa-solid fa-arrow-down me-2"></i>{L.pricing.downgrade}</div>
                              ) : rank?.planName == "starter" ? (
                                <div onClick={() => changePlan(plan.url, interval)}><i className="fa-solid fa-arrow-up me-2"></i>{L.pricing.upgrade}</div>
                              ) : null}
                            </div>
                          );
                        })()}
                      </>
                    )}

                    {!profile && (
                      <a
                        href={`/50off?plan=${plan.url}&from=pricing`}
                      onClick={() => haptic(15)}
                        className="d-block w-100 text-center mt-4 stripe-btn stripe-btn--primary"
                        style={{ padding: '14px 24px' }}
                      >
                        {txt.cta}
                        {rank?.planName == plan && rank?.status == "active" && (<div>{L.pricing.selected}</div>)}
                      </a>
                    )}

                    {/* Trust cues */}
                    <p className="stripe-trust-line mt-3 mb-0">
                      {L.pricing.trustLine}
                    </p>
                  </div>
                </div>
              </div>
              );
            })}
          </div>
        </div>

        {/* Delivery Guarantee */}
        {!profile && (
          <div className="mt-4 pt-4 text-center mx-auto" style={{ maxWidth: '600px' }}>
            <div className="stripe-icon-box stripe-icon-box--green mb-3">
              <i className="fa-solid fa-shield-halved" style={{ color: '#059669', fontSize: '1.2rem' }}></i>
            </div>
            <h3 className="stripe-heading stripe-heading--sm">
              {L.pricing.guaranteeHeading}
            </h3>
            <p className="stripe-body" style={{ fontSize: '1.05rem', lineHeight: 1.7, marginTop: '0.5rem' }}>
              {L.pricing.guaranteeBody}
            </p>
            <div className="d-flex flex-wrap align-items-center justify-content-center gap-4 mt-3 stripe-trust-badges">
              <div className="d-flex align-items-center gap-2">
                <i className="fa-solid fa-lock"></i>
                <span>{L.pricing.noPasswordRequired}</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <i className="fa-solid fa-file-contract"></i>
                <span>{L.pricing.noContracts}</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <i className="fa-solid fa-times-circle"></i>
                <span>{L.pricing.cancelAnytime}</span>
              </div>
            </div>
          </div>
        )}

      </div>

      {/* Confirmation Modal */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} className="rounded-2xl">
        <Modal.Header closeButton className="bg-gradient-to-r from-instagram to-instagram-dark  border-0">
          <Modal.Title className="text-xl font-bold">
            <i className="fas fa-sync-alt mr-2 text-instagram"></i>
            {L.pricing.confirmPlanChange}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-6">
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl shadow-sm border border-blue-100">
            <h4 className="text-lg font-medium text-gray-800 mb-4">{L.pricing.planChangeDetails}</h4>
            {profile && (
              <div className="flex items-center mb-4 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
                <Image 
                  src={photo}
                  width={40}
                  height={40}
                  className="rounded-full mr-3"
                  alt={L.pricing.profileAlt}
                  onError={(e) => { e.target.onerror = null; e.target.src = '/images/default.png'; }}
                />
                <div>
                  <div className="font-medium text-gray-800">{username}</div>
                  <div className="text-sm text-gray-500">{L.pricing.accountLabel(profile?.socials?.[profile?.selectedProfile]?.platform?.charAt(0).toUpperCase() + profile?.socials?.[profile?.selectedProfile]?.platform?.slice(1))}</div>
                </div>
              </div>
            )}
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-32 text-gray-500">{L.pricing.currentPlanLabel}</div>
                <div className="font-semibold text-gray-700">
                  {L.pricing.planTitle(rank?.planName?.charAt(0).toUpperCase() + rank?.planName?.slice(1))}
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-32 text-gray-500">{L.pricing.newPlanLabel}</div>
                <div className="font-semibold">
                  {L.pricing.planTitle(pendingPlanChange?.planName?.charAt(0).toUpperCase() + pendingPlanChange?.planName?.slice(1))}
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-32 text-gray-500">{L.pricing.billingIntervalLabel}</div>
                <div className="font-semibold ">
                  {pendingPlanChange?.interval?.charAt(0).toUpperCase() + pendingPlanChange?.interval?.slice(1)}
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-32 text-gray-500">{L.pricing.priceLabel}</div>
                <div className="font-semibold ">
                  {L.pricing.pricePerMonth(plans.find(p => p.url === pendingPlanChange?.planName)?.price[pendingPlanChange?.interval])}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 bg-gradient-to-r from-amber-50 to-yellow-50 p-6 rounded-xl border border-amber-200">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 pt-1">
                <i className="fas fa-lightbulb text-amber-500 text-xl"></i>
              </div>
              <div>
                <h5 className="text-amber-900 font-medium mb-3">{L.pricing.billingInformation}</h5>
                <p className="text-amber-800 text-sm leading-relaxed m-0">
                  {L.pricing.proratedRefund(getProRata().remainingValue, getProRata().remainingDays)}
                </p>
              </div>
            </div>
          </div>

          <div className="mt-4 flex items-center bg-blue-50 p-4 rounded-xl border border-blue-100">
            <i className="fas fa-info-circle text-blue-500 mr-4"></i>
            <p className="text-blue-800 text-sm m-0">{L.pricing.billingCycleReset}</p>
          </div>

          {/* Payment method picker */}
          <div style={{marginTop: '20px'}}>
            <label style={{fontSize: '0.75rem', fontWeight: 600, color: '#68778d', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '8px', display: 'block'}}>
              {L.pricing.paymentMethod}
            </label>
            <div style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
              {profile?.cards && Object.entries(profile.cards).map(([id, card]) => (
                <div
                  key={id}
                  onClick={() => { setSelectedCard(id); setCardError(''); }}
                  style={{
                    padding: '12px 14px', borderRadius: '10px', cursor: 'pointer',
                    border: selectedCard === id ? '2px solid #635bff' : '1.5px solid #e3e8ee',
                    background: selectedCard === id ? '#f5f3ff' : '#fff',
                    transition: 'all 0.15s ease',
                    display: 'flex', alignItems: 'center', gap: '10px',
                  }}
                >
                  <div style={{
                    width: '32px', height: '32px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: selectedCard === id ? '#ede9fe' : '#f1f5f9',
                  }}>
                    {card.cardnumber.startsWith('4') && <i className="fa-brands fa-cc-visa" style={{color: '#635bff', fontSize: '1rem'}}></i>}
                    {card.cardnumber.startsWith('5') && <i className="fa-brands fa-cc-mastercard" style={{color: '#635bff', fontSize: '1rem'}}></i>}
                    {card.cardnumber.startsWith('3') && <i className="fa-brands fa-cc-amex" style={{color: '#635bff', fontSize: '1rem'}}></i>}
                    {!card.cardnumber.startsWith('3') && !card.cardnumber.startsWith('4') && !card.cardnumber.startsWith('5') && <i className="fa-solid fa-credit-card" style={{color: '#635bff', fontSize: '0.85rem'}}></i>}
                  </div>
                  <span style={{fontWeight: 600, fontSize: '0.85rem', color: '#0a2540'}}>
                    •••• {card.cardnumber.slice(-4)}
                  </span>
                  <span style={{fontSize: '0.78rem', color: '#68778d'}}>{card.exp}</span>
                  {selectedCard === id && (
                    <i className="fas fa-check-circle" style={{marginLeft: 'auto', color: '#635bff', fontSize: '0.9rem'}}></i>
                  )}
                </div>
              ))}

              {/* Add new card */}
              <div
                onClick={() => { setSelectedCard('addCard'); setCardError(''); }}
                style={{
                  padding: '12px 14px', borderRadius: '10px', cursor: 'pointer',
                  border: selectedCard === 'addCard' ? '2px solid #635bff' : '1.5px dashed #d1d5db',
                  background: selectedCard === 'addCard' ? '#f5f3ff' : '#fff',
                  transition: 'all 0.15s ease',
                  display: 'flex', alignItems: 'center', gap: '10px',
                }}
              >
                <div style={{
                  width: '32px', height: '32px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: selectedCard === 'addCard' ? '#ede9fe' : '#f1f5f9',
                }}>
                  <i className="fas fa-plus" style={{color: '#635bff', fontSize: '0.75rem'}}></i>
                </div>
                <span style={{fontWeight: 600, fontSize: '0.85rem', color: '#0a2540'}}>{L.pricing.addNewCard}</span>
                {selectedCard === 'addCard' && (
                  <i className="fas fa-check-circle" style={{marginLeft: 'auto', color: '#635bff', fontSize: '0.9rem'}}></i>
                )}
              </div>
            </div>
          </div>

          {/* New card form */}
          {(!profile?.cards || Object.keys(profile.cards).length === 0 || selectedCard === 'addCard') && (
            <div style={{
              background: '#f6f9fc', borderRadius: '10px', padding: '16px', marginTop: '12px',
              border: '1px solid #e3e8ee'
            }}>
              <div style={{marginBottom: '10px'}}>
                <label style={{fontSize: '0.72rem', fontWeight: 600, color: '#68778d', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '4px', display: 'block'}}>{L.pricing.cardNumberLabel}</label>
                <div style={{position: 'relative'}}>
                  <i className="fas fa-credit-card" style={{position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', fontSize: '0.8rem'}}></i>
                  <Form.Control
                    as={InputMask}
                    type="text"
                    ref={cardRef}
                    placeholder="1234 5678 9012 3456"
                    mask="9999 9999 9999 9999"
                    maskChar=""
                    style={{
                      paddingLeft: '36px', borderRadius: '8px', border: '1.5px solid #e3e8ee',
                      fontSize: '0.88rem', fontWeight: 500, padding: '10px 12px 10px 36px',
                    }}
                  />
                </div>
              </div>
              <div style={{display: 'flex', gap: '10px'}}>
                <div style={{flex: 1}}>
                  <label style={{fontSize: '0.72rem', fontWeight: 600, color: '#68778d', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '4px', display: 'block'}}>{L.pricing.expiryLabel}</label>
                  <div style={{position: 'relative'}}>
                    <i className="fas fa-calendar" style={{position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', fontSize: '0.8rem'}}></i>
                    <Form.Control
                      as={InputMask}
                      maskChar=""
                      type="text"
                      ref={expRef}
                      placeholder={L.pricing.expPlaceholder}
                      mask="99/99"
                      style={{
                        paddingLeft: '36px', borderRadius: '8px', border: '1.5px solid #e3e8ee',
                        fontSize: '0.88rem', fontWeight: 500, padding: '10px 12px 10px 36px',
                      }}
                    />
                  </div>
                </div>
                <div style={{flex: 1}}>
                  <label style={{fontSize: '0.72rem', fontWeight: 600, color: '#68778d', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '4px', display: 'block'}}>{L.pricing.cvvLabel}</label>
                  <div style={{position: 'relative'}}>
                    <i className="fas fa-lock" style={{position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', fontSize: '0.8rem'}}></i>
                    <Form.Control
                      as={InputMask}
                      maskChar=""
                      type="text"
                      ref={cvvRef}
                      placeholder="123"
                      mask="9999"
                      style={{
                        paddingLeft: '36px', borderRadius: '8px', border: '1.5px solid #e3e8ee',
                        fontSize: '0.88rem', fontWeight: 500, padding: '10px 12px 10px 36px',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {cardError && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px',
              padding: '10px 14px', marginTop: '14px', display: 'flex', alignItems: 'center', gap: '8px'
            }}>
              <i className="fas fa-exclamation-circle" style={{color: '#dc2626', fontSize: '0.85rem'}}></i>
              <span style={{color: '#991b1b', fontSize: '0.82rem', fontWeight: 500}}>{cardError}</span>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="light"
            onClick={() => setShowConfirmModal(false)}
            className="px-6 py-2 rounded-full hover:bg-gray-100 transition-colors"
          >
            <i className="fas fa-times mr-2"></i>
            {L.pricing.cancel}
          </Button>
          <Button
            variant="instagram"
            onClick={confirmPlanChange}
            disabled={loading || !selectedCard}
            className={`bg-instagram text-white px-6 py-2 rounded-full hover:bg-instagram-dark ml-3 transition-colors ${loading || !selectedCard ? 'disabled' : ''}`}
          >
            {loading ? (
              <><i className="fas fa-spinner fa-spin mr-2"></i> {L.pricing.processing}</>
            ) : (
              <><i className="fas fa-check mr-2"></i> {L.pricing.confirmChanges}</>
            )}
          </Button>
		  {window.location.hostname !== 'localhost' && <div id="applepaybutton"></div>}
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default Pricing;
